import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import GetInTouch from "./sections/GetInTouch";
import LocationMap from "./sections/LocationMap";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <GetInTouch />
      <LocationMap />
      <Footer />
    </div>;
}